import { use } from 'react';
import { PaginatedSelectContext } from './context';

export function usePaginatedSelectContext() {
  const context = use(PaginatedSelectContext);
  if (!context) {
    throw new Error('PaginatedSelect components must be used within a PaginatedSelect provider');
  }
  return context;
}
